import axios from "axios";
const base_url = process.env.VUE_APP_API_BASE_URL
import { useInteractiveStore } from "../stores/interactive";

axios.defaults.withCredentials = true;

const api = axios.create({
  baseURL: `${base_url}`, 
});

// Response interceptor for global error handling
api.interceptors.response.use(
  response => response, // pass successful responses
  error => {
    const interactiveStore = useInteractiveStore();

    if (error.response) { 
      // ✅ Backend returned an error (status 4xx or 5xx)
      if (error.response.data.message !== "Not logged in.") {
        interactiveStore.backend_message = error.response.data.message || "Server error occurred";
        interactiveStore.display_error_alert_box();
      }
    } else {  
      // ✅ Network error / no response (error.response is undefined here)
      // FIX: Use error.message instead of error.response.data.message
      interactiveStore.backend_message = error.message || "Network error occurred";
      interactiveStore.display_error_alert_box();
    }

    interactiveStore.toggle_loading_overlay(false);
    return Promise.reject(error); // still throw so component catch blocks can handle it
  }
);

export default api;